module.exports = __webpack_public_path__ + "static/img/kehu4.c2bd4bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/kehu4.jpg
// module id = 509
// module chunks = 2 3